import { render } from "./bookNow.vue?vue&type=template&id=18bb45a5&scoped=true"
import script from "./bookNow.vue?vue&type=script&lang=js"
export * from "./bookNow.vue?vue&type=script&lang=js"

import "./bookNow.vue?vue&type=style&index=0&id=18bb45a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bb45a5"]])

export default __exports__